// Article 11a, Consumer Rights Directive (EU 2023/2673):
// Step 1 entry control: unambiguous withdrawal entry (Article 11a CRD)
// Step 2 confirmation control: "confirm withdrawal" (used inside Shopify flow, not here)
export const WITHDRAWAL_ENTRY_LABEL = "Withdraw From Contract";
